import { useSelector } from "react-redux";
import { selectHasPermission, selectIsAdmin } from "../../../store/slices/authSlice";
import { PERMISSIONS_BY_KEY } from "../../../config/permissionsRegistry";
import NoAccessState from "./NoAccessState";

/**
 * Route/section wrapper: renders children only when the current user has
 * `perm` (admins always pass). Otherwise renders <NoAccessState> with the
 * registry label as the reason line. Never redirects.
 *
 * <PermissionRoute perm="calendar.viewClinic"><ClinicCalendarPage/></PermissionRoute>
 * `anyOf` accepts several keys (any one resolving true is enough).
 * `adminOnly` ignores keys and requires selectIsAdmin.
 */
function PermissionRoute({ perm, anyOf = null, adminOnly = false, children, size = "page" }) {
  const keys = anyOf || (perm ? [perm] : []);
  // One boolean out of the selector → stable reference, no spurious re-renders.
  const allowed = useSelector(
    (state) =>
      selectIsAdmin(state) ||
      (!adminOnly && keys.some((k) => selectHasPermission(k)(state) === true)),
  );
  if (allowed) return children;
  const label = keys.length === 1 ? PERMISSIONS_BY_KEY[keys[0]]?.label : null;
  return (
    <NoAccessState
      size={size}
      reason={adminOnly ? "דורש תפקיד מנהל/ת קליניקה" : label ? `הרשאה נדרשת: ${label}` : null}
    />
  );
}

export default PermissionRoute;
